<template>
    <nav class="navbar" @click.stop>
        <ul class="main-menu" ref="mainMenu">
            <li v-for="(submenu, key) in menuItems" :key="key" class="has-submenu"
                :class="{ active: activeMenu === key }" @mouseenter="setActiveMenu(key, $event)"
                @mouseleave="clearActiveMenu" @click="setActiveMenu(key, $event)">
                <a>{{ submenu.label }}</a>
            </li>
        </ul>

        <div v-if="activeMenu" class="active-underline" :style="underlineStyle"></div>

        <div class="submenu-wrapper" v-if="activeMenu" @mouseenter="keepMenuOpen" @mouseleave="clearActiveMenu">
            <div class="bg-container">
                <ul class="submenu" :style="{ left: submenuPosition + 'px' }">
                    <li v-for="item in menuItems[activeMenu].items" :key="item.value">
                        <a @click="navigate(item.value, item.label, menuItems[activeMenu].label)">{{ item.label }}</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapActions } from "vuex";
export default {
    name: 'largeMenu',
    data() {
        return {
            activeMenu: null,
            submenuPosition: 0,
            underlineStyle: { left: '0px', width: '0px' },
            menuItems: {
                kits: {
                    label: "Test Kits", items: [
                        { label: "Management", value: 0 },
                        { label: "Outliers", value: 4 },
                        // { label: "Import Kits", value: 12 },
                        { label: "Import WS Kits", value: 19 },
                        { label: "WS Kits", value: 20 },
                        { label: "Import Amazon kits", value: 13 },
                        { label: "Inactive Kits", value: 15 }
                    ]
                },
                user: {
                    label: "User", items: [
                        { label: "Admins", value: 1 },
                        { label: "Lab Operators", value: 2 },
                        { label: "Customers", value: 8 }
                    ]
                },
                inventory: {
                    label: "Inventory", items: [
                        { label: "Kit Generation", value: 14 },
                        { label: "Items", value: 18 },
                        { label: "Amazon", value: 16 }
                    ]
                },
                order: {
                    label: "Reports", items: [
                        { label: "Woo", value: 11 },
                        { label: "Sales", value: 17 },
                    ]
                },
                automation: {
                    label: "Automation", items: [
                        // { label: "Job Logs", value: 10 },
                        { label: "User Logs", value: 21 }
                    ]
                },
                tool: {
                    label: "Tools", items: [
                        { label: "QR Generator", value: 6 },
                        { label: "URL Generator", value: 7 }
                    ]
                },
                others: {
                    label: "Other", items: [
                        { label: "Research", value: 3 },
                        { label: "Federal Holidays", value: 9 }
                    ]
                }
            }
        };
    },
    methods: {
        ...mapActions([
            "setStatusFilter",
            "setOverDueByShipped",
            "getAdminInfoList",
            "setAdminPginationPage",
            "getLabOperatorInfoList",
            "sendSearchReqAnalytics",
            "sendSearchReqAnalyticsAll",
            "setAnalyticsHead",
            "getPendingInfoList",
            "getAverageReportResultList",
            "getContactCustomers",
            "setCustomerCount",
            "getFederalHolidays",
            "getScheduledJoblogs",
            "setLoader",
            "resetState",
            "setViewReport",
            "setInventory",
            "setLocations",
            "setPagination",
            "setFillocation",
            "setFilItem",
            "setItems",
            "setPage",
            "setInvKits",
            "getInactiveList",
            "setAmazonFbaInv",
            "setSalesData",
            "setWooSalesData",
            "setShowinvkit",
            "setCityState"
        ]),
        setActiveMenu(menu, event) {
            this.activeMenu = menu;
            this.updateSubmenuPosition(menu, event);
        },
        keepMenuOpen() { },
        clearActiveMenu(event) {
            const isHoveringOverMainMenu = this.$refs.mainMenu.contains(event.relatedTarget);
            const isHoveringOverSubmenuWrapper = this.$el.contains(event.relatedTarget);

            if (!isHoveringOverMainMenu && !isHoveringOverSubmenuWrapper) {
                this.activeMenu = null;
            }
        },
        updateSubmenuPosition(menu, event) {
            if (event) {
                const menuItem = event.currentTarget;
                const menuItemRect = menuItem.getBoundingClientRect();
                this.submenuPosition = menuItemRect.left - 5;

                this.underlineStyle = {
                    left: `${menuItem.offsetLeft + 10}px`,
                    width: `${menuItem.offsetWidth - 20}px`,
                };
            }
        },
        navigate(val, label, main_label) {
            for (let key in this.showsubmenu) {
                this.showsubmenu[key] = false;
            }
            this.clearActiveMenu({ relatedTarget: null });
            this.resetState();
            let show_state = false;
            if (val == 0 || val == 4) {
                show_state = true;
            }
            this.$eventBus.$emit("breadcrums", {
                path: [{ text: main_label, link: "/dashboard" },
                { text: label }], show: show_state
            })

            if (val === 0) {
                this.setStatusFilter([]);
                this.getAdminInfoList("kits").then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
                this.$eventBus.$emit("showoutlinerfilters", { showfilter: true, value: val });
            } else if (val === 1) {
                this.setAdminPginationPage(null).then(() => {
                    this.getAdminInfoList("admins").then(res => {
                        this.$eventBus.$emit("title", { show: false, value: val, label: label });
                    });
                });
            } else if (val === 2) {
                this.setAdminPginationPage(null).then(() => {
                    this.getLabOperatorInfoList("labOps").then(res => {
                        this.$eventBus.$emit("title", { show: false, value: val, label: label });
                    });
                });
            } else if (val === 3) {
                this.sendSearchReqAnalytics().then(res => {
                    this.setAnalyticsHead({ status: 3, type: null, show: false, item: null, count: null, total: null });
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
                this.sendSearchReqAnalyticsAll();
                this.setCityState();
            } else if (val === 4) {
                this.setStatusFilter([]);
                this.setOverDueByShipped(null);
                this.getPendingInfoList("pending").then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
            } else if (val === 5) {
                this.setAdminPginationPage(null).then(() => {
                    this.getAverageReportResultList("avg").then(res => {
                        this.$eventBus.$emit("title", { show: false, value: val, label: label });
                    });
                });
            } else if (val === 6) {
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            } else if (val === 7) {
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            } else if (val === 8) {
                this.setAdminPginationPage(null).then(() => {
                    this.setCustomerCount(0).then(() => {
                        this.getContactCustomers(null).then(res => {
                            this.$eventBus.$emit("title", { show: false, value: val, label: label });
                        });
                    });
                });
            } else if (val === 9) {
                this.getFederalHolidays().then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
            } else if (val === 10) {
                this.getScheduledJoblogs().then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
            } else if (val === 12) {
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            } else if (val === 13 || val === 19 || val === 20 || val === 21 || val === 11) {
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            } else if (val === 14) {
                this.setLoader(true);
                this.setLocations();
                this.setItems();
                this.setFillocation('');
                this.setFilItem('');
                this.setInvKits(false);
                this.setPage(1).then(() => {
                    this.setInventory().then(async res => {
                        this.setLoader(false);
                        this.$eventBus.$emit("title", { show: false, value: val, label: label });
                        this.setShowinvkit(true);
                    });
                });
            } else if (val === 15) {
                this.getInactiveList("kits").then(res => {
                    this.$eventBus.$emit("title", { show: false, value: val, label: label });
                });
            } else if (val === 16) {
                this.setAmazonFbaInv();
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            } else if (val === 17) {
                this.setSalesData();
                this.setWooSalesData();
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            } else if (val === 18) {
                this.setLoader(true);
                this.setLocations();
                this.setItems();
                this.setFillocation('');
                this.setFilItem('');
                this.setInvKits(false);
                this.setPage(1).then(() => {
                    this.setInventory().then(async res => {
                        this.setLoader(false);
                        this.$eventBus.$emit("title", { show: false, value: 14 });
                        this.setShowinvkit(false);
                    });
                });
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.closeMenuOnOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeMenuOnOutsideClick);
    }
};
</script>

<style scoped>
body,
ul,
li,
a {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
}

.navbar {
    background-color: #fff;
    padding: 0px 0;
    text-align: center;
    position: relative;
    display: flex;
    justify-content: center;
    height: 100px;
}

.main-menu {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
}

.main-menu li {
    margin: 0 15px;
    margin-left: 0px;
    margin-right: 0px;
    position: relative;
    height: 100%;
    justify-content: center;
    align-items: center;
    display: inline-flex;
}

.main-menu li a {
    color: #6B6B6B;
    padding: 10px 10px;
    cursor: pointer;
    font-weight: 400;
    display: block;
    transition: color 0.3s ease;
    font-size: 17px;
}

.main-menu li.active a {
    color: #005EB8;
}

.active-underline {
    position: absolute;
    top: 60px;
    height: 1.3px;
    background-color: #005fb8;
    transition: left 0.3s ease, width 0.3s ease;
    z-index: 10000;
}

.bg-container {
    background-color: #ffffff00;
    width: inherit;
    min-height: 300px;
    height: auto;
    margin-top: 1px;
}

.submenu-wrapper {
    position: fixed;
    top: 68px;
    left: 13px;
    min-height: 300px;
    height: auto;
    width: max-content;
    background-color: #e9e9e900;
    text-align: center;
    padding: 0px;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    /* box-shadow: 0 1px 5px rgba(36, 36, 36, 0.1); */
}

.submenu {
    position: absolute;
    display: block;
    background-color: #ffffff;
    transform: translateX(-50%);
    text-align: left;
    min-width: 150px;
    left: 0;
    top: 0px;
    transform: translateX(0);
    transition: left 0.3s ease;
    box-shadow: 0 1px 5px rgba(36, 36, 36, 0.1);
}

.submenu li {
    margin: 5px 0;
}

.submenu li a {
    color: #6B6B6B;
    padding: 10px 20px;
    padding-left: 15px;
    display: block;
    cursor: pointer;
    white-space: nowrap;
}

.submenu li a:hover {
    color: #005EB8;
}
</style>